var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgRuzhu = function SvgRuzhu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.3 26.989c.15 0 .292.067.387.183a6.088 6.088 0 0 0 5.268 2.203.5.5 0 0 1 .545.498v18.326a3.5 3.5 0 0 1-3.5 3.5h-6a.5.5 0 0 1-.5-.5V40.7a4 4 0 1 0-8 0v10.499a.5.5 0 0 1-.5.5H12a3.5 3.5 0 0 1-3.5-3.5V29.873a.5.5 0 0 1 .545-.498 6.088 6.088 0 0 0 5.269-2.203.501.501 0 0 1 .772 0A6.087 6.087 0 0 0 19.8 29.4a6.087 6.087 0 0 0 4.714-2.228.501.501 0 0 1 .772 0A6.087 6.087 0 0 0 30 29.4a6.087 6.087 0 0 0 4.714-2.228l.079-.078a.5.5 0 0 1 .693.078A6.087 6.087 0 0 0 40.2 29.4a6.088 6.088 0 0 0 4.714-2.228l.08-.078a.5.5 0 0 1 .306-.105ZM16.5 36.7a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1h-6Zm32.347-28a3.5 3.5 0 0 1 3.315 2.38l3.354 9.938A5.6 5.6 0 0 1 45.3 25.615a5.6 5.6 0 0 1-10.2-.002 5.6 5.6 0 0 1-10.2 0 5.6 5.6 0 0 1-10.2.002 5.6 5.6 0 0 1-10.214-4.6l3.352-9.934A3.5 3.5 0 0 1 11.153 8.7h37.694Z",
    fill: "url(#ruzhu_svg__a)",
    stroke: "url(#ruzhu_svg__b)",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ruzhu_svg__a",
    x1: 30,
    y1: 9.2,
    x2: 30,
    y2: 51.199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCE6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ruzhu_svg__b",
    x1: 30,
    y1: 9.2,
    x2: 30,
    y2: 51.199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.2
  })))));
};

export default SvgRuzhu;